import { Model } from '../parents/model';

export class CreditsCouponsModel extends Model {
  static ATTR_ID = 'id';

  static EMBED_CREDIT_COUPON = 'credit_coupon';


  get id() {
    return this.attributes[CreditsCouponsModel.ATTR_ID];
  }

  get creditCoupon() {
    return this.embeds[CreditsCouponsModel.EMBED_CREDIT_COUPON];
  }
}
